export default {
  "dashboard-layout": () => import("/opt/build/repo/layouts/dashboard-layout.vue").then(m => m.default || m)
}